import User from "./User";

export default class Evaluator {
  constructor(data) {
    this.id = data.id;
    this.name = data.name;
    this.loadEvaluatees(data.evaluatees);
  }

  /**
   * 評価対象者を読み込む
   * @param evaluatees
   */
  loadEvaluatees(evaluatees) {
    if (Array.isArray(evaluatees)) {
      this.evaluatees = {};
      evaluatees.forEach(e => {
        const evaluatee = new User(e);
        this.evaluatees[evaluatee.id] = evaluatee;
      });

      /**
       * @type {Map<number, number[]>}
       */
      this.evaluateeStages = new Map();
      evaluatees.forEach(e => {
        const stage = e.pivot.stage;
        if (this.evaluateeStages.has(e.id)) {
          this.evaluateeStages.get(e.id).push(stage);
        } else {
          this.evaluateeStages.set(e.id, [stage]);
        }
      });

    } else {
      this.evaluatees = {};
      this.evaluateeStages = new Map();
    }

  }

  /**
   * 指定の被評価者を評価するステージ番号の配列を返す
   *
   * @param {number} evaluateeId
   * @return {number[]}
   */
  getStages(evaluateeId) {
      return this.evaluateeStages.get(evaluateeId);
  }

  /**
   * 指定のステージ番号で指定の被評価者を評価するように決められているか判断する
   *
   * @param {number} stage
   * @param {number} evaluateeId
   * @returns {boolean}
   */
  shouldEvaluate(stage, evaluateeId) {
    const evaluatee = this.evaluatees[evaluateeId];
    const evaluation = evaluatee?.otherEvaluations[stage];

    // 既に評価確定済なら編集させない
    if (evaluation && evaluation.status === 'CLOSED') {
      return false;
    }

    // 最終評価が始まっていた場合は評価させない
    if (evaluatee?.isFinalEvaluationStarted) {
      return false;
    }

    return this.evaluateeStages.get(evaluateeId).includes(stage);
  }

  /**
   * 未確定の評価があるか一つでもあるかチェックする
   *
   * @returns {boolean}
   */
  hasOpenEvaluation() {
    if (!this.evaluatees) return false;

    // 確定前の評価が一つでもあるか判定
    for (let evaluateeId of this.evaluateeStages.keys()) {
      const evaluatee = this.evaluatees[evaluateeId];
      if (this.hasOpenEvaluationOf(evaluatee)) {
        return true;
      }
    }
    return false;
  }

  /**
   * 指定のユーザーの評価が編集中かどうか判断する
   *
   * @param {User} evaluatee
   * @returns {boolean}
   */
  hasOpenEvaluationOf(evaluatee) {
    // 最終評価が始まっていたら未確定の評価があっても無視する
    if (evaluatee.isFinalEvaluationStarted) {
      return false;
    }

    let res = false;
    this.getTargetEvaluationsOf(evaluatee).forEach(evaluation => {
      if (evaluation && evaluation.status !== 'CLOSED') {
        res = true;
      }
    });
    return res;
  }

  /**
   * 指定のユーザーに対して、Evaluatorが評価すべきEvaluationの配列を返す
   *
   * @param {User} evaluatee
   * @return {Evaluation[]}
   */
  getTargetEvaluationsOf(evaluatee) {
    const stages = this.evaluateeStages.get(evaluatee.id);

    return stages.map(stage => {
      return evaluatee?.otherEvaluations[stage];
    }).filter(e => e);
  }
}
